import { render, staticRenderFns } from "./TableEducation.vue?vue&type=template&id=070849c1&scoped=true"
import script from "./TableEducation.vue?vue&type=script&lang=js"
export * from "./TableEducation.vue?vue&type=script&lang=js"
import style0 from "./TableEducation.vue?vue&type=style&index=0&id=070849c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070849c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataFooter } from 'vuetify/lib/components/VDataIterator';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataFooter,VDataTable,VIcon,VTextField})
